import { render, staticRenderFns } from "./SidebarBody.vue?vue&type=template&id=257aac6c&"
import script from "./SidebarBody.vue?vue&type=script&lang=js&"
export * from "./SidebarBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports